import { render, staticRenderFns } from "./DirectInterviewPoint.vue?vue&type=template&id=18e26ee5&scoped=true&"
import script from "./DirectInterviewPoint.vue?vue&type=script&lang=js&"
export * from "./DirectInterviewPoint.vue?vue&type=script&lang=js&"
import style0 from "./DirectInterviewPoint.vue?vue&type=style&index=0&id=18e26ee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e26ee5",
  null
  
)

export default component.exports